export default {
  filterData : {
    Products: {
      label: '製品',
      allFilterLabel: "すべての製品",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "トピック",
      allFilterLabel: "すべてのトピック",
      items: [
        { name: "アクセス管理", id: "Access management" },
        { name: "アナリティクスと監視", id: "Analytics and monitoring" },
        { name: "アプリケーションデリバリーおよびセキュリティ", id: "Application delivery and security" },
        { name: "シトリックスとGoogle", id: "Citrix and Google" },
        { name: "CitrixとMicrosoft", id: "Citrix and Microsoft" },
        { name: "クラウドへの移行", id: "Cloud migration" },
        { name: "比較", id: "Compare" },
        { name: "コンテンツコラボレーション", id: "Content collaboration" },
        { name: "デジタルワークスペース", id: "Digital workspaces" },
        { name: "従業員エクスペリエンス", id: "Employee experience" },
        { name: "ハイブリッドクラウド", id: "Hybrid cloud" },
        { name: "ハイブリッドワーク", id: "Hybrid work" },
        { name: "管理と最適化", id: "Manage and optimize" },
        { name: "マイクロサービスとdevOps", id: "Microservices and devOps" },
        { name: "オンボーディングとユーザー教育支援", id: "Onboarding and adoption" },
        { name: "パートナーの統合", id: "Partner integrations" },
        { name: "製品概要", id: "Product overview" },
        { name: "セキュリティとコンプライアンス", id: "Security and compliance" },
        { name: "中小企業", id: "Small business" },
        { name: "仕様", id: "Specifications" },
        { name: "持続可能性", id: "Sustainability" },
        { name: "統合エンドポイント管理", id: "Unified endpoint management" },
        { name: "VDIとDaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: 'タイプ',
      allFilterLabel: "すべてのタイプ",
      items: [
        { name: "アナリストレポート", id: "Analyst report" },
        { name: "評価ツール", id: "Assessment tool" },
        { name: "お客様事例", id: "Customer story" },
        { name: "データシート", id: "Data sheet" },
        { name: "デモ", id: "Demo" },
        { name: "eBook", id: "eBook" },
        { name: "ガイド", id: "Guide" },
        { name: "インフォグラフィック", id: "Infographic" },
        { name: "インタラクティブツアー", id: "Interactive tour" },
        { name: "ポッドキャスト", id: "Podcast" },
        { name: "リソースキット", id: "Resource kit" },
        { name: "ソリューションブリーフ", id: "Solution brief" },
        { name: "テクニカルブリーフ", id: "Technical brief" },
        { name: "ビデオ", id: "Video" },
        { name: "ウェビナー", id: "Webinar" },
        { name: "ホワイトペーパー", id: "White paper" },
      ],
    },
    Industry: {
      label: "業種",
      allFilterLabel: "すべての業種",
      items: [
        { name: "教育", id: "education" },
        { name: "金融サービス", id: "financial_service" },
        { name: "官公庁・自治体", id: "government" },
        { name: "医療", id: "healthcare" },
        { name: "製造業", id: "manufacturing" },
        { name: "小売業", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "ライブラリの検索",
    titles : {
      label1: "現在のトレンド",
      label2: "最新リソース",
      label3: "最近の閲覧状況",
      label4: "推奨されるリソース"
    },
    showMoreLabel: "さらに表示",
    clearAllSelected: "選択したすべての項目をクリア",
    searchResults: "検索結果",
    clearAllFilters: "すべてのフィルタをクリア",
    noResultsFound: "選択した条件を満たすアセットはありません",
    resetView: "ビューをリセット",
    filterLabel: "フィルタ",
    filteredRes: "検索結果",
    filterRes: "検索結果を絞り込む",
    clearAllCta: "すべてクリア",
    applyCta: "申請する",
    view: "表示",
    includeEnglishRes:"英語のリソースを含む"
  };
  